"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Chip_1 = require("./Chip");
exports.default = Chip_1.default;
//# sourceMappingURL=index.js.map